<template>
  <div class="grid w-fit grid-flow-col items-center gap-0.5">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="w-fit cursor-pointer rounded-lg px-2 py-0.5"
      :class="{ 'bg-specialprojectsection/10': index === selectedItem }"
      @click="emit('update:selected-item', item.id)"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  selectedItem: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['update:selected-item']);
</script>
